import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type {
  IAffiliateProgramCommissionListItem,
} from '../types';
import {
  AFFILIATE_PROGRAM_COMMISSIONS_LIST_API_URL,
  AFFILIATE_PROGRAM_COMMISSIONS_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS,
} from '../constants';

export default function useAffiliateProgramCommissionsListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IAffiliateProgramCommissionListItem>, Error> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliateProgramCommissionListItem>>({
    queryKey: [AFFILIATE_PROGRAM_COMMISSIONS_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliateProgramCommissionListItem>>(
      AFFILIATE_PROGRAM_COMMISSIONS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
